// Display merchandise quantities only. Never change Shopify's cart or money fields.
(() => {
  const config = document.querySelector('[data-agfn-cart-count-config]');
  const settings = config ? JSON.parse(config.textContent) : {};
  function count(cart) {
    if (!Array.isArray(cart?.items)) return Number(cart?.item_count) || 0;
    return cart.items.reduce((total, item) => {
      const fee = (settings.productId && String(item.product_id) === String(settings.productId)) ||
        (settings.handle && item.handle === settings.handle);
      return total + (fee ? 0 : Number(item.quantity) || 0);
    }, 0);
  }
  function labels(quantity) {
    const template = quantity === 1 ? settings.one : settings.other;
    if (template) document.querySelectorAll('[data-agfn-cart-count-label]').forEach(node => {
      node.textContent = template.replace('__COUNT__', String(quantity));
    });
    if (settings.view) document.querySelectorAll('[data-agfn-cart-view]').forEach(node => {
      node.textContent = settings.view.replace('__COUNT__', String(quantity));
    });
  }
  // Ella calls this wherever it updates a displayed count, including quick add.
  window.AGFNCartCount = cart => {const quantity = count(cart); labels(quantity); return quantity;};
  window.AGFNCartCount.render = cart => {
    const quantity = window.AGFNCartCount(cart);
    document.querySelectorAll('[data-cart-count]').forEach(node => {
      node.textContent = quantity >= 100 && node.closest('.cart-count-bubble') ? (settings.many || '99+') : String(quantity);
    });
    document.querySelectorAll('[data-cart-text]').forEach(node => {
      node.textContent = quantity === 1 ? settings.item : settings.items;
    });
  };
  document.addEventListener('cart-update', event => {
    if (Array.isArray(event.detail?.items)) window.AGFNCartCount.render(event.detail);
  });
})();
